/*
  Singles Browser enhancement script.
  The page stays server-rendered and works without JavaScript for filtering.
  This script only adds the rich browser interactions that the approved HTML
  prototype already had: list/grid toggles, filter drawer control, variant
  drawer behavior, and Ajax cart feedback.
*/
document.addEventListener('DOMContentLoaded', function () {
  var browserRoots = document.querySelectorAll('[data-collection-browser]');

  if (!browserRoots.length) {
    return;
  }

  browserRoots.forEach(function (browserRoot) {
    var sharedCartFeedback = window.TCGHiveCartFeedback || null;
    var defaultView = browserRoot.getAttribute('data-default-view') || 'grid';
    /*
      Each browser page can opt into its own saved view preference. This keeps
      the Sealed grid-only page from overwriting the Singles list/grid choice.
    */
    var storageKey = browserRoot.getAttribute('data-view-storage-key') || 'tcghive-singles-browser-view';
    var storedView = window.localStorage ? window.localStorage.getItem(storageKey) : null;
    var filterDrawer = browserRoot.querySelector('[data-filter-drawer]');
    var filterDrawerOverlay = browserRoot.querySelector('[data-filter-drawer-overlay]');
    var openDrawerButton = browserRoot.querySelector('[data-filter-drawer-open]');
    var closeDrawerButtons = browserRoot.querySelectorAll('[data-filter-drawer-close]');
    var quickPriceButtons = browserRoot.querySelectorAll('[data-quick-price]');
    var filterLanguageOptionButtons = browserRoot.querySelectorAll('[data-filter-language-option]');
    var desktopFilterForms = browserRoot.querySelectorAll('[data-browser-filter-form="desktop"]');
    var setSearchRoots = browserRoot.querySelectorAll('[data-filter-search-root]');
    var priceRanges = browserRoot.querySelectorAll('[data-price-range]');
    var sortDropdowns = browserRoot.querySelectorAll('[data-sort-dropdown]');
    var viewButtons = browserRoot.querySelectorAll('[data-view-toggle]');
    var variantDrawer = browserRoot.querySelector('[data-variant-drawer]');
    var variantDrawerOverlay = browserRoot.querySelector('[data-variant-drawer-overlay]');
    var variantDrawerCloseButtons = browserRoot.querySelectorAll('[data-variant-drawer-close]');
    var variantDrawerList = browserRoot.querySelector('[data-variant-drawer-list]');
    var variantDrawerImage = browserRoot.querySelector('[data-variant-drawer-image]');
    var variantDrawerSet = browserRoot.querySelector('[data-variant-drawer-set]');
    var variantDrawerProduct = browserRoot.querySelector('[data-variant-drawer-product]');
    var variantDrawerError = browserRoot.querySelector('[data-variant-drawer-error]');
    var variantDrawerAddButton = browserRoot.querySelector('[data-variant-drawer-add-button]');
    var variantQtyDecrease = browserRoot.querySelector('[data-variant-qty-decrease]');
    var variantQtyIncrease = browserRoot.querySelector('[data-variant-qty-increase]');
    var variantQtyValue = browserRoot.querySelector('[data-variant-qty-value]');
    var cartToastRoot = document.querySelector('[data-cart-toast-root]');
    var cartToast = cartToastRoot ? cartToastRoot.querySelector('[data-cart-toast]') : null;
    var cartToastTitle = cartToastRoot ? cartToastRoot.querySelector('[data-cart-toast-title]') : null;
    var cartToastProduct = cartToastRoot ? cartToastRoot.querySelector('[data-cart-toast-product]') : null;
    var cartToastVariant = cartToastRoot ? cartToastRoot.querySelector('[data-cart-toast-variant]') : null;
    var cartToastActions = cartToastRoot ? cartToastRoot.querySelector('[data-cart-toast-actions]') : null;
    var cartToastCloseButton = cartToastRoot ? cartToastRoot.querySelector('[data-cart-toast-close]') : null;
    var scrollTopButton = browserRoot.querySelector('[data-scroll-top]');
    var desktopBreakpoint = window.matchMedia('(min-width: 1024px)');
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var activeView = storedView || defaultView;
    var filterLabelPreferenceKey = 'tcghive:singles-filter-label-language:v1';
    var storefrontFilterLanguage = (browserRoot.getAttribute('data-filter-label-storefront') || 'en').toLowerCase();
    var defaultFilterLanguage = (browserRoot.getAttribute('data-filter-label-default') || 'en').toLowerCase();
    var filterSubmitTimer = null;
    var drawerState = {
      product: null,
      selectedVariantId: null,
      quantity: 1
    };
    var isSinglesBrowser = browserRoot.classList.contains('collection-browser--singles');

    function syncPageLock() {
      var hasOpenFilterDrawer = Boolean(filterDrawer && !filterDrawer.hidden && filterDrawer.classList.contains('is-open'));
      var hasOpenVariantDrawer = Boolean(
        variantDrawer &&
          !variantDrawer.hidden &&
          variantDrawer.classList.contains('is-open')
      );

      document.body.classList.toggle('tcghive-mobile-nav-open', hasOpenFilterDrawer || hasOpenVariantDrawer);
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function resolveFilterLabelLanguage() {
      var storedValue = null;

      /*
        English storefronts should always stay English, even if the customer
        previously saved a German preference while browsing the German locale.
      */
      if (storefrontFilterLanguage !== 'de') {
        return 'en';
      }

      try {
        storedValue = window.localStorage ? window.localStorage.getItem(filterLabelPreferenceKey) : null;
      } catch (error) {
        storedValue = null;
      }

      if (storedValue === 'en' || storedValue === 'de') {
        return storedValue;
      }

      return defaultFilterLanguage === 'en' ? 'en' : 'de';
    }

    function applyFilterLabelLanguage(nextLanguage) {
      var resolvedLanguage = nextLanguage === 'en' ? 'en' : 'de';

      browserRoot.setAttribute('data-filter-label-language', resolvedLanguage);

      browserRoot.querySelectorAll('[data-filter-language-label]').forEach(function (labelElement) {
        var nextText =
          resolvedLanguage === 'de'
            ? labelElement.getAttribute('data-label-de')
            : labelElement.getAttribute('data-label-en');

        if (nextText) {
          labelElement.textContent = nextText;
        }
      });

      filterLanguageOptionButtons.forEach(function (button) {
        var isActive = button.getAttribute('data-filter-language-option') === resolvedLanguage;

        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function persistFilterLabelLanguage(nextLanguage) {
      try {
        if (window.localStorage && storefrontFilterLanguage === 'de') {
          window.localStorage.setItem(filterLabelPreferenceKey, nextLanguage);
        }
      } catch (error) {
        /* Ignore storage failures and keep the current session interactive. */
      }
    }

    function setView(view) {
      activeView = view === 'grid' ? 'grid' : 'list';
      browserRoot.classList.toggle('is-grid-view', activeView === 'grid');
      browserRoot.classList.toggle('is-list-view', activeView !== 'grid');

      viewButtons.forEach(function (button) {
        var isActive = button.getAttribute('data-view-toggle') === activeView;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (window.localStorage) {
        window.localStorage.setItem(storageKey, activeView);
      }
    }

    function stripHiddenConditionFilterOnLoad() {
      var currentUrl;
      var hadHiddenCondition = false;

      /*
        Condition is still a valid variant attribute, but it is no longer a
        customer-facing browse filter. When an older URL still carries that
        query param, reload the clean URL so the page does not stay filtered by
        an invisible control.
      */
      if (!isSinglesBrowser) {
        return false;
      }

      currentUrl = new URL(window.location.href);
      hadHiddenCondition = currentUrl.searchParams.has('filter.v.option.condition');

      if (!hadHiddenCondition) {
        return false;
      }

      currentUrl.searchParams.delete('filter.v.option.condition');
      currentUrl.searchParams.delete('page');
      window.location.replace(currentUrl.toString());
      return true;
    }

    function openFilterDrawer() {
      if (!filterDrawer || !filterDrawerOverlay) {
        return;
      }

      filterDrawer.hidden = false;
      filterDrawerOverlay.hidden = false;

      window.requestAnimationFrame(function () {
        filterDrawer.classList.add('is-open');
        syncPageLock();
      });
    }

    function closeFilterDrawer() {
      if (!filterDrawer || !filterDrawerOverlay) {
        return;
      }

      filterDrawer.classList.remove('is-open');
      filterDrawerOverlay.hidden = true;

      window.setTimeout(function () {
        if (!filterDrawer.classList.contains('is-open')) {
          filterDrawer.hidden = true;
        }

        syncPageLock();
      }, 220);
    }

    function openVariantDrawer() {
      if (!variantDrawer || !variantDrawerOverlay) {
        return;
      }

      /*
        The add-to-cart toast is intentionally persistent, but it should never
        sit on top of the variant drawer actions when the customer wants to pick
        another version.
      */
      closeCartToast();

      variantDrawer.hidden = false;
      variantDrawerOverlay.hidden = false;

      window.requestAnimationFrame(function () {
        variantDrawer.classList.add('is-open');
        syncPageLock();
      });
    }

    function closeVariantDrawer() {
      if (!variantDrawer || !variantDrawerOverlay) {
        return;
      }

      variantDrawer.classList.remove('is-open');
      variantDrawerOverlay.hidden = true;

      window.setTimeout(function () {
        if (!variantDrawer.classList.contains('is-open')) {
          variantDrawer.hidden = true;
        }

        syncPageLock();
      }, 220);
    }

    function closeCartToast() {
      if (sharedCartFeedback && typeof sharedCartFeedback.closeCartToast === 'function') {
        sharedCartFeedback.closeCartToast();
        return;
      }

      if (!cartToast) {
        return;
      }

      cartToast.classList.remove('is-visible', 'is-error');
      cartToast.hidden = true;
    }

    function closeSortDropdown(dropdownRoot) {
      if (!dropdownRoot) {
        return;
      }

      var trigger = dropdownRoot.querySelector('[data-sort-trigger]');
      var menu = dropdownRoot.querySelector('[data-sort-menu]');

      if (trigger) {
        trigger.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }

      if (menu) {
        menu.hidden = true;
      }
    }

    function closeAllSortDropdowns(exceptRoot) {
      sortDropdowns.forEach(function (dropdownRoot) {
        if (exceptRoot && dropdownRoot === exceptRoot) {
          return;
        }

        closeSortDropdown(dropdownRoot);
      });
    }

    function closeSetSearch(rootElement) {
      if (!rootElement) {
        return;
      }

      var inputElement = rootElement.querySelector('[data-filter-search]');
      var panel = rootElement.querySelector('[data-filter-search-panel]');

      if (inputElement) {
        inputElement.setAttribute('aria-expanded', 'false');
      }

      if (panel) {
        panel.hidden = true;
      }
    }

    function closeAllSetSearches(exceptRoot) {
      setSearchRoots.forEach(function (rootElement) {
        if (exceptRoot && rootElement === exceptRoot) {
          return;
        }

        closeSetSearch(rootElement);
      });
    }

    function normalizeFilterSearchText(value) {
      var normalizedValue = String(value || '').toLowerCase();

      /*
        Set names can contain apostrophes, accents, punctuation, and encoded
        entities. Normalizing keeps the in-panel search fast and forgiving while
        still using only the already-rendered Shopify filter directory.
      */
      if (typeof normalizedValue.normalize === 'function') {
        normalizedValue = normalizedValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      }

      return normalizedValue.replace(/\s+/g, ' ').trim();
    }

    function updateScrollTopVisibility() {
      if (!scrollTopButton) {
        return;
      }

      var isVisible = window.scrollY > 360;
      scrollTopButton.classList.toggle('is-visible', isVisible);
      scrollTopButton.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    }

    /*
      Browser quick-filter rails hide their scrollbar on touch-first layouts, so
      desktop needs an explicit drag interaction when the presets overflow. The
      drag threshold keeps normal clicks working while still allowing the user
      to grab the rail directly on top of a chip.
    */
    function initQuickFilterRails() {
      var quickFilterRails = browserRoot.querySelectorAll('.collection-browser__quick-filter-row[data-drag-scroll]');

      quickFilterRails.forEach(function (rail) {
        var pointerId = null;
        var startX = 0;
        var startScrollLeft = 0;
        var didDrag = false;
        var suppressClick = false;
        var dragThreshold = 5;

        function hasOverflow() {
          return rail.scrollWidth > rail.clientWidth + 1;
        }

        function syncState() {
          rail.classList.toggle('is-scrollable', hasOverflow());
        }

        function endPointer(event) {
          if (pointerId === null) {
            syncState();
            return;
          }

          rail.classList.remove('is-dragging');

          if (
            rail.hasPointerCapture &&
            event &&
            typeof rail.hasPointerCapture === 'function' &&
            rail.hasPointerCapture(pointerId)
          ) {
            rail.releasePointerCapture(pointerId);
          }

          pointerId = null;
          didDrag = false;
          window.requestAnimationFrame(syncState);
        }

        rail.addEventListener('pointerdown', function (event) {
          if (event.pointerType === 'touch' || event.button !== 0 || !hasOverflow()) {
            return;
          }

          pointerId = event.pointerId;
          startX = event.clientX;
          startScrollLeft = rail.scrollLeft;
          didDrag = false;
        });

        rail.addEventListener('pointermove', function (event) {
          var deltaX = 0;

          if (pointerId === null || event.pointerId !== pointerId) {
            return;
          }

          deltaX = event.clientX - startX;

          if (!didDrag && Math.abs(deltaX) < dragThreshold) {
            return;
          }

          if (!didDrag) {
            didDrag = true;
            suppressClick = true;
            rail.classList.add('is-dragging');

            if (
              rail.setPointerCapture &&
              typeof rail.hasPointerCapture === 'function' &&
              !rail.hasPointerCapture(event.pointerId)
            ) {
              rail.setPointerCapture(event.pointerId);
            }
          }

          event.preventDefault();
          rail.scrollLeft = startScrollLeft - deltaX;
        });

        rail.addEventListener('pointerup', endPointer);
        rail.addEventListener('pointercancel', endPointer);
        rail.addEventListener('lostpointercapture', endPointer);

        rail.addEventListener(
          'click',
          function (event) {
            if (!suppressClick) {
              return;
            }

            event.preventDefault();
            event.stopPropagation();
            suppressClick = false;
          },
          true
        );

        rail.addEventListener('focusin', function (event) {
          var focusedChip = event.target.closest('.collection-browser__quick-filter');

          if (!focusedChip || !rail.contains(focusedChip)) {
            return;
          }

          focusedChip.scrollIntoView({
            behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        });

        window.addEventListener(
          'resize',
          function () {
            syncState();
          },
          { passive: true }
        );

        syncState();
      });
    }

    function showCartToast(options) {
      if (sharedCartFeedback && typeof sharedCartFeedback.showCartToast === 'function') {
        sharedCartFeedback.showCartToast(options);
        return;
      }

      if (!cartToast || !cartToastTitle || !cartToastProduct || !cartToastVariant || !cartToastActions) {
        return;
      }

      var hasActions = options && options.showActions !== false;

      cartToast.classList.toggle('is-error', options.type === 'error');
      cartToastTitle.textContent = options.title || browserRoot.getAttribute('data-browser-success-title') || '';
      cartToastProduct.textContent = options.productTitle || '';
      cartToastVariant.textContent = options.variantSummary || '';
      cartToastVariant.hidden = !options.variantSummary;
      cartToastActions.hidden = !hasActions;
      cartToast.hidden = false;

      window.requestAnimationFrame(function () {
        cartToast.classList.add('is-visible');
      });
    }

    function applyQuickPrice(maxValue, shouldReset) {
      var minParam = browserRoot.getAttribute('data-price-min-param');
      var maxParam = browserRoot.getAttribute('data-price-max-param');

      if (!minParam || !maxParam) {
        return;
      }

      var nextUrl = new URL(window.location.href);

      nextUrl.searchParams.delete('page');

      if (shouldReset) {
        nextUrl.searchParams.delete(minParam);
        nextUrl.searchParams.delete(maxParam);
      } else {
        nextUrl.searchParams.set(minParam, '0');
        nextUrl.searchParams.set(maxParam, String(maxValue));
      }

      window.location.href = nextUrl.toString();
    }

    function removeDefaultPriceParams(nextUrl) {
      var minParam = browserRoot.getAttribute('data-price-min-param') || '';
      var maxParam = browserRoot.getAttribute('data-price-max-param') || '';
      var rangeMax = Number(browserRoot.getAttribute('data-price-range-max') || 0);
      var minValue = Number(String(nextUrl.searchParams.get(minParam) || '').replace(',', '.'));
      var maxValue = Number(String(nextUrl.searchParams.get(maxParam) || '').replace(',', '.'));

      /*
        Shopify treats default price bounds as active filters when they are
        present in the URL. Tag toggles such as Foil should not inherit those
        defaults from the filter form or from an older broken URL.
      */
      if (minParam && nextUrl.searchParams.has(minParam) && Number.isFinite(minValue) && minValue <= 0) {
        nextUrl.searchParams.delete(minParam);
      }

      if (
        maxParam &&
        nextUrl.searchParams.has(maxParam) &&
        Number.isFinite(maxValue) &&
        Number.isFinite(rangeMax) &&
        rangeMax > 0 &&
        maxValue >= rangeMax
      ) {
        nextUrl.searchParams.delete(maxParam);
      }
    }

    function normalizeCollectionBasePath(rawPath) {
      var normalizedPath = String(rawPath || '').trim();

      if (!normalizedPath.length) {
        return '';
      }

      if (normalizedPath.length > 1) {
        normalizedPath = normalizedPath.replace(/\/+$/, '');
      }

      return normalizedPath || '/';
    }

    function getCollectionBasePath() {
      return normalizeCollectionBasePath(
        browserRoot.getAttribute('data-collection-base-url') || window.location.pathname
      );
    }

    function parseLegacyTagHandlesFromPath(pathname) {
      var collectionBasePath = getCollectionBasePath();
      var normalizedPath = normalizeCollectionBasePath(pathname || window.location.pathname);
      var legacyHandleSegment = '';
      var seenHandles = Object.create(null);

      if (!collectionBasePath || normalizedPath === collectionBasePath) {
        return [];
      }

      if (normalizedPath.indexOf(collectionBasePath + '/') !== 0) {
        return [];
      }

      legacyHandleSegment = normalizedPath.slice(collectionBasePath.length + 1);

      if (!legacyHandleSegment.length) {
        return [];
      }

      return legacyHandleSegment
        .split('+')
        .map(function (handle) {
          return decodeURIComponent(handle || '').trim();
        })
        .filter(function (handle) {
          if (!handle || seenHandles[handle]) {
            return false;
          }

          seenHandles[handle] = true;
          return true;
        });
    }

    function buildLegacyTaggedPath(tagHandles) {
      var collectionBasePath = getCollectionBasePath();
      var uniqueHandles = [];
      var seenHandles = Object.create(null);

      (tagHandles || []).forEach(function (handle) {
        var normalizedHandle = String(handle || '').trim();

        if (!normalizedHandle || seenHandles[normalizedHandle]) {
          return;
        }

        seenHandles[normalizedHandle] = true;
        uniqueHandles.push(normalizedHandle);
      });

      if (!uniqueHandles.length) {
        return collectionBasePath;
      }

      return collectionBasePath + '/' + uniqueHandles.join('+');
    }

    function formUsesLegacyTagFallback(formElement) {
      return Boolean(formElement && formElement.querySelector('[data-legacy-tag-input]'));
    }

    function submitBrowserFilterForm(formElement) {
      var nextUrl = null;
      var nextFormData = null;
      var legacyTagHandles = [];

      if (!formElement) {
        return;
      }

      if (!formUsesLegacyTagFallback(formElement)) {
        formElement.submit();
        return;
      }

      nextUrl = new URL(window.location.href);
      nextFormData = new window.FormData(formElement);

      formElement.querySelectorAll('[data-legacy-tag-input]:checked').forEach(function (inputElement) {
        var legacyTagHandle = inputElement.getAttribute('data-legacy-tag-handle') || '';

        if (legacyTagHandle) {
          legacyTagHandles.push(legacyTagHandle);
        }
      });

      nextUrl.pathname = buildLegacyTaggedPath(legacyTagHandles);
      nextUrl.search = '';

      nextFormData.forEach(function (value, name) {
        /*
          Legacy tag filters use Shopify collection tag URLs. The price range
          inputs still live in the same form, so their default bounds must not
          be serialized when the customer only toggles a tag like Foil.
        */
        var shouldSkipDefaultPriceValue = false;

        if (!name || name === 'page') {
          return;
        }

        if (value == null || String(value).trim() === '') {
          return;
        }

        formElement.querySelectorAll('[data-price-range]').forEach(function (priceRangeElement) {
          var minParam = priceRangeElement.getAttribute('data-min-param') || '';
          var maxParam = priceRangeElement.getAttribute('data-max-param') || '';
          var rangeMax = Number(priceRangeElement.getAttribute('data-range-max') || 0);
          var numericValue = Number(String(value).replace(',', '.'));

          if (!Number.isFinite(numericValue)) {
            return;
          }

          if (name === minParam && numericValue <= 0) {
            shouldSkipDefaultPriceValue = true;
          }

          if (name === maxParam && Number.isFinite(rangeMax) && numericValue >= rangeMax) {
            shouldSkipDefaultPriceValue = true;
          }
        });

        if (shouldSkipDefaultPriceValue) {
          return;
        }

        nextUrl.searchParams.append(name, value);
      });

      removeDefaultPriceParams(nextUrl);
      window.location.assign(nextUrl.toString());
    }

    function toggleLegacyTagHandle(legacyTagHandle) {
      var nextUrl = new URL(window.location.href);
      var activeHandles = parseLegacyTagHandlesFromPath(nextUrl.pathname);
      var normalizedHandle = String(legacyTagHandle || '').trim();
      var nextHandles = [];
      var isActive = activeHandles.indexOf(normalizedHandle) !== -1;

      if (!normalizedHandle) {
        return;
      }

      if (isActive) {
        nextHandles = activeHandles.filter(function (handle) {
          return handle !== normalizedHandle;
        });
      } else {
        nextHandles = activeHandles.slice();
        nextHandles.push(normalizedHandle);
      }

      nextUrl.pathname = buildLegacyTaggedPath(nextHandles);
      nextUrl.searchParams.delete('page');
      removeDefaultPriceParams(nextUrl);
      window.location.assign(nextUrl.toString());
    }

    function removeLegacyTagHandle(legacyTagHandle) {
      var nextUrl = new URL(window.location.href);
      var nextHandles = parseLegacyTagHandlesFromPath(nextUrl.pathname).filter(function (handle) {
        return handle !== String(legacyTagHandle || '').trim();
      });

      nextUrl.pathname = buildLegacyTaggedPath(nextHandles);
      nextUrl.searchParams.delete('page');
      removeDefaultPriceParams(nextUrl);
      window.location.assign(nextUrl.toString());
    }

    function submitSortForm(sortForm) {
      var hiddenInput = sortForm ? sortForm.querySelector('[data-sort-input]') : null;
      var nextSortValue = hiddenInput ? hiddenInput.value : '';
      var nextUrl = new URL(window.location.href);

      if (!sortForm || !hiddenInput) {
        return;
      }

      nextUrl.searchParams.delete('page');

      if (nextSortValue) {
        nextUrl.searchParams.set('sort_by', nextSortValue);
      } else {
        nextUrl.searchParams.delete('sort_by');
      }

      window.location.assign(nextUrl.toString());
    }

    function syncPriceRange(priceRangeRoot) {
      var minRange = priceRangeRoot.querySelector('[data-price-min-range]');
      var maxRange = priceRangeRoot.querySelector('[data-price-max-range]');
      var minInput = priceRangeRoot.querySelector('[data-price-min-input]');
      var maxInput = priceRangeRoot.querySelector('[data-price-max-input]');
      var fill = priceRangeRoot.querySelector('[data-price-range-fill]');
      var rangeMax = Number(priceRangeRoot.getAttribute('data-range-max') || 500);
      var usesIntegerValues = priceRangeRoot.getAttribute('data-price-integer-values') === 'true';
      var owningForm = priceRangeRoot.closest('form');
      var priceCommitTimer = null;

      if (!minRange || !maxRange || !minInput || !maxInput || !fill) {
        return;
      }

      if (!Number.isFinite(rangeMax)) {
        rangeMax = 0;
      }

      /*
        A zero or missing Shopify range means the collection does not expose a
        usable price spread yet. Keep the shared slider synced at 0/0 and stop
        before we calculate percentages against a fake range.
      */
      if (
        rangeMax <= 0 ||
        minRange.disabled ||
        maxRange.disabled ||
        minInput.disabled ||
        maxInput.disabled
      ) {
        minRange.value = '0';
        maxRange.value = '0';
        minInput.value = '0';
        maxInput.value = '0';
        fill.style.left = '0%';
        fill.style.width = '0%';
        return;
      }

      function readSafeNumber(rawValue, fallbackValue) {
        var stringValue = String(rawValue == null ? '' : rawValue).trim();

        if (!stringValue.length) {
          return fallbackValue;
        }

        var parsedValue = Number(stringValue);

        return Number.isFinite(parsedValue) ? parsedValue : fallbackValue;
      }

      function toControlValue(rawValue) {
        if (usesIntegerValues) {
          return String(Math.round(rawValue));
        }

        return String(Number((Math.round(rawValue * 100) / 100).toFixed(2)));
      }

      function schedulePriceRangeCommit() {
        /*
          Desktop buyers should only leave the page once they finished the price
          interaction. We therefore submit the filter form only after the final
          change event, not while the thumb is still moving.
        */
        if (
          !desktopBreakpoint.matches ||
          !owningForm ||
          owningForm.getAttribute('data-browser-filter-form') !== 'desktop'
        ) {
          return;
        }

        window.clearTimeout(priceCommitTimer);
        priceCommitTimer = window.setTimeout(function () {
          submitBrowserFilterForm(owningForm);
        }, 220);
      }

      function normalizeValues(source) {
        /*
          The source argument tells us which control the customer just changed.
          We must read that control first, otherwise an older synced field can
          immediately overwrite the new thumb/input value during dragging.
        */
        var minValue = readSafeNumber(minRange.value, 0);
        var maxValue = readSafeNumber(maxRange.value, rangeMax);

        if (source === 'init') {
          minValue = readSafeNumber(minInput.value, minValue);
          maxValue = readSafeNumber(maxInput.value, maxValue);
        } else if (source === 'min-input') {
          minValue = readSafeNumber(minInput.value, minValue);
          maxValue = readSafeNumber(maxInput.value, maxValue);
        } else if (source === 'max-input') {
          minValue = readSafeNumber(minInput.value, minValue);
          maxValue = readSafeNumber(maxInput.value, maxValue);
        } else if (source === 'min-range') {
          minValue = readSafeNumber(minRange.value, minValue);
          maxValue = readSafeNumber(maxRange.value, maxValue);
        } else if (source === 'max-range') {
          minValue = readSafeNumber(minRange.value, minValue);
          maxValue = readSafeNumber(maxRange.value, maxValue);
        }

        if (source === 'min-range' || source === 'min-input') {
          minValue = Math.min(minValue, maxValue);
        } else if (source === 'max-range' || source === 'max-input') {
          maxValue = Math.max(maxValue, minValue);
        }

        minValue = Math.max(0, Math.min(minValue, rangeMax));
        maxValue = Math.max(0, Math.min(maxValue, rangeMax));

        if (minValue > maxValue) {
          minValue = maxValue;
        }

        minRange.value = toControlValue(minValue);
        maxRange.value = toControlValue(maxValue);
        minInput.value = toControlValue(minValue);
        maxInput.value = toControlValue(maxValue);

        var startPercent = (minValue / rangeMax) * 100;
        var endPercent = (maxValue / rangeMax) * 100;

        fill.style.left = startPercent + '%';
        fill.style.width = Math.max(endPercent - startPercent, 0) + '%';
      }

      minRange.addEventListener('input', function () {
        normalizeValues('min-range');
      });

      maxRange.addEventListener('input', function () {
        normalizeValues('max-range');
      });

      minInput.addEventListener('input', function () {
        normalizeValues('min-input');
      });

      maxInput.addEventListener('input', function () {
        normalizeValues('max-input');
      });

      minRange.addEventListener('change', function () {
        normalizeValues('min-range');
        schedulePriceRangeCommit();
      });

      maxRange.addEventListener('change', function () {
        normalizeValues('max-range');
        schedulePriceRangeCommit();
      });

      minInput.addEventListener('change', function () {
        normalizeValues('min-input');
        schedulePriceRangeCommit();
      });

      maxInput.addEventListener('change', function () {
        normalizeValues('max-input');
        schedulePriceRangeCommit();
      });

      normalizeValues('init');
    }

    function scheduleDesktopFilterSubmit(formElement) {
      if (!desktopBreakpoint.matches) {
        return;
      }

      window.clearTimeout(filterSubmitTimer);
      filterSubmitTimer = window.setTimeout(function () {
        submitBrowserFilterForm(formElement);
      }, 140);
    }

    function parseProductData(cardElement) {
      if (!cardElement) {
        return null;
      }

      if (cardElement._browserProductData) {
        return cardElement._browserProductData;
      }

      var productDataScript = cardElement.querySelector('[data-browser-product-json]');

      if (!productDataScript) {
        return null;
      }

      try {
        cardElement._browserProductData = JSON.parse(productDataScript.textContent);
      } catch (error) {
        cardElement._browserProductData = null;
      }

      return cardElement._browserProductData;
    }

    function findVariant(productData, variantId) {
      if (!productData || !productData.variants || !productData.variants.length) {
        return null;
      }

      var resolvedVariantId = String(variantId);

      for (var index = 0; index < productData.variants.length; index += 1) {
        if (String(productData.variants[index].id) === resolvedVariantId) {
          return productData.variants[index];
        }
      }

      return null;
    }

    function resolveDrawerDefaultVariant(productData) {
      var currentVariant = findVariant(productData, productData && productData.currentVariantId);

      if (currentVariant && currentVariant.available) {
        return currentVariant;
      }

      if (productData && productData.variants) {
        for (var index = 0; index < productData.variants.length; index += 1) {
          if (productData.variants[index].available) {
            return productData.variants[index];
          }
        }
      }

      return currentVariant || (productData && productData.variants ? productData.variants[0] : null);
    }

    function buildVariantStatusText(variantData) {
      var availableLabel = browserRoot.getAttribute('data-browser-available-label') || '';
      var soldOutLabel = browserRoot.getAttribute('data-browser-sold-out-label') || '';
      var stockTemplate = browserRoot.getAttribute('data-browser-stock-template') || '';

      if (!variantData) {
        return soldOutLabel;
      }

      if (!variantData.available) {
        return soldOutLabel;
      }

      if (variantData.inventoryCount) {
        if (stockTemplate.indexOf('[count]') !== -1) {
          return stockTemplate.replace('[count]', String(variantData.inventoryCount));
        }

        return String(variantData.inventoryCount);
      }

      return availableLabel;
    }

    function getVariantCartMaxQuantity(variantData) {
      var inventoryMax = Number(variantData && variantData.inventoryCount);
      var quantityRuleMax = Number(variantData && variantData.quantityRuleMax);
      var maxQuantity = null;

      if (Number.isFinite(inventoryMax) && inventoryMax > 0) {
        maxQuantity = Math.floor(inventoryMax);
      }

      if (Number.isFinite(quantityRuleMax) && quantityRuleMax > 0) {
        quantityRuleMax = Math.floor(quantityRuleMax);
        maxQuantity = maxQuantity === null ? quantityRuleMax : Math.min(maxQuantity, quantityRuleMax);
      }

      return maxQuantity;
    }

    function clearDrawerError() {
      if (!variantDrawerError) {
        return;
      }

      variantDrawerError.hidden = true;
      variantDrawerError.textContent = '';
    }

    function showDrawerError(message) {
      if (!variantDrawerError) {
        return;
      }

      variantDrawerError.hidden = false;
      variantDrawerError.textContent = message || browserRoot.getAttribute('data-browser-add-error') || '';
    }

    function renderVariantRows() {
      if (!variantDrawerList || !drawerState.product) {
        return;
      }

      var variantMarkup = drawerState.product.variants
        .map(function (variantData) {
          var variantSummary = variantData.summary || variantData.title || '';
          var statusText = buildVariantStatusText(variantData);
          var isSelected = String(variantData.id) === String(drawerState.selectedVariantId);
          var rowClasses = 'collection-browser__variant-row';
          var statusClasses = 'collection-browser__variant-row-status';
          var disabledAttribute = '';

          if (isSelected) {
            rowClasses += ' is-selected';
          }

          if (variantData.available) {
            statusClasses += ' is-available';
          } else {
            rowClasses += ' is-unavailable';
            statusClasses += ' is-unavailable';
            disabledAttribute = ' disabled';
          }

          return (
            '<button class="' +
            rowClasses +
            '" type="button" data-variant-row data-variant-id="' +
            escapeHtml(variantData.id) +
            '"' +
            disabledAttribute +
            '>' +
            '<span class="collection-browser__variant-row-copy">' +
            '<span class="collection-browser__variant-row-top">' +
            '<span class="collection-browser__variant-row-summary">' +
            escapeHtml(variantSummary) +
            '</span>' +
            '</span>' +
            '<span class="' +
            statusClasses +
            '">' +
            escapeHtml(statusText) +
            '</span>' +
            '</span>' +
            '<span class="collection-browser__variant-row-price">' +
            escapeHtml(variantData.price || '') +
            '</span>' +
            '</button>'
          );
        })
        .join('');

      variantDrawerList.innerHTML = variantMarkup;
    }

    function syncDrawerSelection(variantId) {
      if (!drawerState.product) {
        return;
      }

      var selectedVariant = findVariant(drawerState.product, variantId);

      if (!selectedVariant || !selectedVariant.available) {
        return;
      }

      drawerState.selectedVariantId = String(selectedVariant.id);

      if (variantDrawerList) {
        variantDrawerList.querySelectorAll('[data-variant-row]').forEach(function (rowElement) {
          var isSelected = rowElement.getAttribute('data-variant-id') === drawerState.selectedVariantId;
          rowElement.classList.toggle('is-selected', isSelected);
        });
      }

      if (variantDrawerImage && selectedVariant.image) {
        variantDrawerImage.hidden = false;
        variantDrawerImage.src = selectedVariant.image;
        variantDrawerImage.alt = drawerState.product.title || '';
      }

      if (variantDrawerAddButton) {
        variantDrawerAddButton.disabled = false;
      }

      setDrawerQuantity(drawerState.quantity);
      clearDrawerError();
    }

    function setDrawerQuantity(nextQuantity) {
      var selectedVariant = drawerState.product
        ? findVariant(drawerState.product, drawerState.selectedVariantId)
        : null;
      var maxQuantity = selectedVariant ? getVariantCartMaxQuantity(selectedVariant) : null;

      drawerState.quantity = Math.max(1, Number(nextQuantity) || 1);
      if (maxQuantity !== null) {
        drawerState.quantity = Math.min(drawerState.quantity, maxQuantity);
      }

      if (variantQtyValue) {
        variantQtyValue.textContent = String(drawerState.quantity);
      }
    }

    function populateVariantDrawer(productData) {
      if (!productData || !variantDrawerSet || !variantDrawerProduct) {
        return;
      }

      drawerState.product = productData;
      setDrawerQuantity(1);
      clearDrawerError();

      variantDrawerSet.textContent = productData.setName || '';
      variantDrawerProduct.textContent = productData.title || '';

      if (variantDrawerImage) {
        if (productData.image) {
          variantDrawerImage.hidden = false;
          variantDrawerImage.src = productData.image;
          variantDrawerImage.alt = productData.title || '';
        } else {
          variantDrawerImage.hidden = true;
          variantDrawerImage.removeAttribute('src');
          variantDrawerImage.alt = '';
        }
      }

      renderVariantRows();

      var defaultVariant = resolveDrawerDefaultVariant(productData);

      if (defaultVariant && defaultVariant.available) {
        syncDrawerSelection(defaultVariant.id);
      } else {
        drawerState.selectedVariantId = null;

        if (variantDrawerAddButton) {
          variantDrawerAddButton.disabled = true;
        }
      }
    }

    function buildCartErrorMessage(responsePayload) {
      if (!responsePayload) {
        return browserRoot.getAttribute('data-browser-add-error') || '';
      }

      if (typeof responsePayload.description === 'string' && responsePayload.description !== '') {
        return responsePayload.description;
      }

      if (typeof responsePayload.message === 'string' && responsePayload.message !== '') {
        return responsePayload.message;
      }

      return browserRoot.getAttribute('data-browser-add-error') || '';
    }

    function refreshCartCount() {
      if (sharedCartFeedback && typeof sharedCartFeedback.refreshCartCount === 'function') {
        return sharedCartFeedback.refreshCartCount();
      }

      var cartStateUrl = browserRoot.getAttribute('data-cart-state-url');

      if (!cartStateUrl) {
        return Promise.resolve(null);
      }

      return fetch(cartStateUrl, {
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('cart-state');
          }

          return response.json();
        })
        .then(function (cartState) {
          var nextItemCount = cartState && typeof cartState.item_count === 'number' ? cartState.item_count : 0;

          document.querySelectorAll('.site-cart-badge, [data-cart-count]').forEach(function (countElement) {
            countElement.textContent = String(nextItemCount);
          });

          return cartState;
        });
    }

    function addVariantToCart(options) {
      if (sharedCartFeedback && typeof sharedCartFeedback.addVariantToCart === 'function') {
        return sharedCartFeedback.addVariantToCart(options);
      }

      var cartAddUrl = browserRoot.getAttribute('data-cart-add-url');
      var requestBody = {
        id: Number(options.variantId),
        quantity: Number(options.quantity || 1)
      };

      if (!cartAddUrl || !requestBody.id) {
        return Promise.reject(new Error(browserRoot.getAttribute('data-browser-add-error') || ''));
      }

      return fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(requestBody)
      })
        .then(function (response) {
          return response.json().then(function (payload) {
            if (!response.ok) {
              var cartError = new Error(buildCartErrorMessage(payload));
              cartError.userMessage = buildCartErrorMessage(payload);
              throw cartError;
            }

            return payload;
          });
        })
        .then(function () {
          return refreshCartCount();
        })
        .then(function () {
          return true;
        });
    }

    function handleCardAdd(formElement) {
      var productCard = formElement.closest('[data-browser-product-card]');
      var productData = parseProductData(productCard);
      var variantField = formElement.querySelector('input[name="id"]');
      var variantData = findVariant(productData, variantField && variantField.value);

      if (!variantField || !variantData || !variantData.available) {
        showCartToast({
          type: 'error',
          title: browserRoot.getAttribute('data-browser-error-title') || '',
          productTitle: productData ? productData.title : '',
          variantSummary: browserRoot.getAttribute('data-browser-add-error') || '',
          showActions: false
        });
        return;
      }

      addVariantToCart({
        variantId: variantData.id,
        quantity: 1,
        maxQuantity: getVariantCartMaxQuantity(variantData)
      })
        .then(function () {
          showCartToast({
            type: 'success',
            title: browserRoot.getAttribute('data-browser-success-title') || '',
            productTitle: productData.title,
            variantSummary: variantData.summary || variantData.title || '',
            showActions: true
          });
        })
        .catch(function (error) {
          showCartToast({
            type: 'error',
            title: browserRoot.getAttribute('data-browser-error-title') || '',
            productTitle: productData ? productData.title : '',
            variantSummary: error.userMessage || error.message || browserRoot.getAttribute('data-browser-add-error') || '',
            showActions: false
          });
        });
    }

    function handleDrawerAdd() {
      var selectedVariant = findVariant(drawerState.product, drawerState.selectedVariantId);

      if (!selectedVariant || !selectedVariant.available) {
        showDrawerError(browserRoot.getAttribute('data-browser-add-error') || '');
        return;
      }

      addVariantToCart({
        variantId: selectedVariant.id,
        quantity: drawerState.quantity,
        maxQuantity: getVariantCartMaxQuantity(selectedVariant)
      })
        .then(function () {
          closeVariantDrawer();
          showCartToast({
            type: 'success',
            title: browserRoot.getAttribute('data-browser-success-title') || '',
            productTitle: drawerState.product ? drawerState.product.title : '',
            variantSummary: selectedVariant.summary || selectedVariant.title || '',
            showActions: true
          });
        })
        .catch(function (error) {
          showDrawerError(error.userMessage || error.message || browserRoot.getAttribute('data-browser-add-error') || '');
        });
    }

    if (stripHiddenConditionFilterOnLoad()) {
      return;
    }

    applyFilterLabelLanguage(resolveFilterLabelLanguage());
    setView(activeView);

    filterLanguageOptionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var nextLanguage = button.getAttribute('data-filter-language-option') === 'en' ? 'en' : 'de';

        applyFilterLabelLanguage(nextLanguage);
        persistFilterLabelLanguage(nextLanguage);
      });
    });

    viewButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setView(button.getAttribute('data-view-toggle'));
      });
    });

    if (openDrawerButton) {
      openDrawerButton.addEventListener('click', openFilterDrawer);
    }

    closeDrawerButtons.forEach(function (button) {
      button.addEventListener('click', closeFilterDrawer);
    });

    if (filterDrawerOverlay) {
      filterDrawerOverlay.addEventListener('click', closeFilterDrawer);
    }

    variantDrawerCloseButtons.forEach(function (button) {
      button.addEventListener('click', closeVariantDrawer);
    });

    if (variantDrawerOverlay) {
      variantDrawerOverlay.addEventListener('click', closeVariantDrawer);
    }

    if (cartToastCloseButton) {
      cartToastCloseButton.addEventListener('click', closeCartToast);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeFilterDrawer();
        closeVariantDrawer();
        closeCartToast();
        closeAllSortDropdowns();
        closeAllSetSearches();
      }
    });

    quickPriceButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var maxValue = Number(button.getAttribute('data-quick-price') || 0);
        var shouldReset = button.classList.contains('is-active');

        if (maxValue > 0) {
          applyQuickPrice(maxValue, shouldReset);
        }
      });
    });

    desktopFilterForms.forEach(function (formElement) {
      formElement.addEventListener('change', function (event) {
        var target = event.target;

        if (!target) {
          return;
        }

        if (target.matches('[data-price-min-input], [data-price-max-input], [data-price-min-range], [data-price-max-range]')) {
          return;
        }

        if (target.matches('[data-filter-search]')) {
          return;
        }

        if (target.matches('input, select')) {
          submitBrowserFilterForm(formElement);
        }
      });
    });

    sortDropdowns.forEach(function (dropdownRoot) {
      var sortForm = dropdownRoot.closest('[data-sort-form]');
      var trigger = dropdownRoot.querySelector('[data-sort-trigger]');
      var menu = dropdownRoot.querySelector('[data-sort-menu]');
      var hiddenInput = sortForm ? sortForm.querySelector('[data-sort-input]') : null;
      var currentLabel = dropdownRoot.querySelector('[data-sort-current-label]');
      var optionButtons = dropdownRoot.querySelectorAll('[data-sort-option]');

      /*
        Mobile sort triggers do not need a dedicated current-label node to open
        and submit the selected value. The label node is optional there, so we
        only require the pieces that are genuinely necessary for the dropdown.
      */
      if (!trigger || !menu || !hiddenInput) {
        return;
      }

      trigger.addEventListener('click', function () {
        var shouldOpen = menu.hidden;

        closeAllSortDropdowns(dropdownRoot);

        if (!shouldOpen) {
          return;
        }

        trigger.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        menu.hidden = false;
      });

      optionButtons.forEach(function (optionButton) {
        optionButton.addEventListener('click', function () {
          var nextValue = optionButton.getAttribute('data-sort-value') || '';
          var nextLabel = optionButton.getAttribute('data-sort-label') || optionButton.textContent.trim();

          hiddenInput.value = nextValue;
          if (currentLabel) {
            currentLabel.textContent = nextLabel;
          }

          optionButtons.forEach(function (nestedButton) {
            var isActive = nestedButton === optionButton;
            nestedButton.classList.toggle('is-active', isActive);
            nestedButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          closeSortDropdown(dropdownRoot);
          submitSortForm(sortForm);
        });
      });
    });

    setSearchRoots.forEach(function (searchRoot) {
      var inputElement = searchRoot.querySelector('[data-filter-search]');
      var panel = searchRoot.querySelector('[data-filter-search-panel]');
      var emptyState = searchRoot.querySelector('[data-filter-search-empty]');
      var items = searchRoot.querySelectorAll('[data-filter-search-item]');

      if (!inputElement || !panel) {
        return;
      }

      function filterSetOptions() {
        var searchValue = normalizeFilterSearchText(inputElement.value);
        var visibleItems = 0;

        items.forEach(function (item) {
          var label = normalizeFilterSearchText(
            item.getAttribute('data-filter-search-item') || item.textContent || ''
          );
          var matches = searchValue === '' || label.indexOf(searchValue) !== -1;

          item.hidden = !matches;
          item.classList.toggle('is-filter-search-hidden', !matches);
          item.setAttribute('aria-hidden', matches ? 'false' : 'true');

          if (matches) {
            visibleItems += 1;
          }
        });

        if (emptyState) {
          emptyState.hidden = visibleItems !== 0;
        }
      }

      function openSetSearch() {
        closeAllSetSearches(searchRoot);
        filterSetOptions();
        panel.hidden = false;
        inputElement.setAttribute('aria-expanded', 'true');
      }

      inputElement.addEventListener('focus', openSetSearch);
      inputElement.addEventListener('input', openSetSearch);
    });

    initQuickFilterRails();
    priceRanges.forEach(syncPriceRange);
    updateScrollTopVisibility();

    if (scrollTopButton) {
      scrollTopButton.addEventListener('click', function () {
        window.scrollTo({
          top: 0,
          behavior: prefersReducedMotion.matches ? 'auto' : 'smooth'
        });
      });
    }

    window.addEventListener(
      'scroll',
      function () {
        updateScrollTopVisibility();
      },
      { passive: true }
    );

    browserRoot.addEventListener('submit', function (event) {
      var filterForm = event.target.closest('[data-browser-filter-form]');
      var addForm = event.target.closest('[data-browser-add-form]');

      if (filterForm) {
        if (formUsesLegacyTagFallback(filterForm)) {
          event.preventDefault();
          submitBrowserFilterForm(filterForm);
        }

        return;
      }

      if (!addForm) {
        return;
      }

      /*
        Shared Ajax add-to-cart now owns any form that opted into the global
        data-tcghive-cart-form contract. The browser-specific fallback only
        handles legacy local forms that have not been migrated.
      */
      if (addForm.hasAttribute('data-tcghive-cart-form')) {
        return;
      }

      event.preventDefault();
      handleCardAdd(addForm);
    });

    browserRoot.addEventListener('click', function (event) {
      var legacyTagToggle = event.target.closest('[data-legacy-tag-toggle]');
      var legacyTagRemove = event.target.closest('[data-remove-legacy-tag]');
      var drawerTrigger = event.target.closest('[data-browser-variant-drawer-trigger]');

      if (legacyTagToggle) {
        event.preventDefault();
        toggleLegacyTagHandle(legacyTagToggle.getAttribute('data-legacy-tag-handle'));
        return;
      }

      if (legacyTagRemove) {
        event.preventDefault();
        removeLegacyTagHandle(legacyTagRemove.getAttribute('data-legacy-tag-handle'));
        return;
      }

      if (drawerTrigger) {
        var productCard = drawerTrigger.closest('[data-browser-product-card]');
        var productData = parseProductData(productCard);

        if (!productData) {
          return;
        }

        populateVariantDrawer(productData);
        openVariantDrawer();
      }
    });

    document.addEventListener('click', function (event) {
      var clickedSortDropdown = event.target.closest('[data-sort-dropdown]');
      var clickedSetSearch = event.target.closest('[data-filter-search-root]');

      if (!clickedSortDropdown) {
        closeAllSortDropdowns();
      } else {
        closeAllSortDropdowns(clickedSortDropdown);
      }

      if (!clickedSetSearch) {
        closeAllSetSearches();
      } else {
        closeAllSetSearches(clickedSetSearch);
      }
    });

    if (variantDrawerList) {
      variantDrawerList.addEventListener('click', function (event) {
        var variantRow = event.target.closest('[data-variant-row]');

        if (!variantRow) {
          return;
        }

        syncDrawerSelection(variantRow.getAttribute('data-variant-id'));
      });
    }

    if (variantDrawerAddButton) {
      variantDrawerAddButton.addEventListener('click', handleDrawerAdd);
    }

    if (variantQtyDecrease) {
      variantQtyDecrease.addEventListener('click', function () {
        setDrawerQuantity(drawerState.quantity - 1);
      });
    }

    if (variantQtyIncrease) {
      variantQtyIncrease.addEventListener('click', function () {
        setDrawerQuantity(drawerState.quantity + 1);
      });
    }
  });
});
